export default "__VITE_ASSET__XsaY5k0a__"